import {createLazyComponent} from 'helpers/createLazyComponent'
import React from 'react'

const CourseClassExamAttemptLazy = createLazyComponent(() => import('./CourseClassExamAttempt'))

const CourseClassExamAttempt = (props) => <CourseClassExamAttemptLazy {...props} />

export default CourseClassExamAttempt
